export default function PHP_sscanf() {
  return (
    <div>
      <h1>PHP_sscanf</h1>
    </div>
  );
}
